import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    ProductsServiceProxy,
    CommonLookupServiceProxy,
    CreateOrEditProductDto,
    DropDownLookupDto,
    ProductUnitMappingDto,
    ProductBarcodeDto,
    ProductRawMaterialMappingDto,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { debug } from 'util';
import { SettingService } from 'abp-ng2-module';
import { AppSessionService } from '../../../shared/common/session/app-session.service';

@Component({
    templateUrl: './create-or-edit-product.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditProductComponent extends AppComponentBase implements OnInit {
    active = false;
    saving = false;

    product: CreateOrEditProductDto = new CreateOrEditProductDto();
    productUnitMapping: ProductUnitMappingDto = new ProductUnitMappingDto();
    productRawMaterialMapping: ProductRawMaterialMappingDto = new ProductRawMaterialMappingDto();
    productBarcode: ProductBarcodeDto = new ProductBarcodeDto();
    unitName = '';
    departmentName = '';
    categoryName = '';
    subCategoryName = '';
    brandName = '';
    vendorName = '';
    taxName = '';

    allUnits: DropDownLookupDto[];
    allCartonUnits: DropDownLookupDto[];
    allDepartments: DropDownLookupDto[];
    allCategorys: DropDownLookupDto[];
    allSubCategorys: DropDownLookupDto[];
    allBrands: DropDownLookupDto[];
    allVendors: DropDownLookupDto[];
    allTaxs: DropDownLookupDto[];
    allRawMaterials: DropDownLookupDto[];

    totalQtyOnHand = 0;
    
    
    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('Product'), '/app/inventory/products'),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _productsServiceProxy: ProductsServiceProxy,
        private _commonLookupService: CommonLookupServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService
    ) {
        super(injector);
    }

    itemCodeAuto = this.appSession.inventorySetting.itemCodeAuto;
    
    ngOnInit(): void {
        this.show(this._activatedRoute.snapshot.queryParams['id']);
    }

    removeUnitMapping(index: number) {
        this.product.productUnitMappings.splice(index, 1);

        if (this.product.productUnitMappings.length == 0) {
            this.addUnitMapping();
        }

        if (this.product.productUnitMappings.length == 0) {
            this.addRawMaterial();
        }
    }

    removeRawMaterialMapping(index: number) {
        this.product.productRawMaterialMappings.splice(index, 1);

        if (this.product.productRawMaterialMappings.length == 0) {
            this.addRawMaterial();
        }

        if (this.product.productRawMaterialMappings.length == 0) {
            this.addRawMaterial();
        }
    }

    addRawMaterial(): void {
        if (this.product.productRawMaterialMappings == null) this.product.productRawMaterialMappings = [];
        this.productRawMaterialMapping = new ProductRawMaterialMappingDto();
       
        this.product.productRawMaterialMappings.push(this.productRawMaterialMapping);
    }

    addUnitMapping(): void {
        if (this.product.productUnitMappings == null) this.product.productUnitMappings = [];
        this.productUnitMapping = new ProductUnitMappingDto();
        
        this.product.productUnitMappings.push(this.productUnitMapping);
    }

    show(productId?: number): void {
        this._productsServiceProxy.getProductForEdit(productId).subscribe((result) => {
            this.product = result.product;
            this.product.productUnitMappings = result.productUnitMappings;
            this.product.productRawMaterialMappings = result.productRawMaterialMappings;
            this.product.productBarcodes = result.productBarcodes;
            this.product.productLocations = result.productLocations;
            this.unitName = result.unitName;
            this.departmentName = result.departmentName;
            this.categoryName = result.categoryName;
            this.subCategoryName = result.subCategoryName;
            this.brandName = result.brandName;
            this.vendorName = result.vendorName;
            this.taxName = result.taxName;
            if (this.product.id === null) {
                this.product.isActive = true;
                this.product.productType = 1;
                this.product.itemCodeAuto = this.itemCodeAuto;
            }
            this.active = true;
            if (this.product.productUnitMappings.length == 0) {

                this.addUnitMapping();
            }
            if (this.product.productRawMaterialMappings.length == 0) {

                this.addRawMaterial();
            }

            this.product.productLocations.forEach(c => {

                this.totalQtyOnHand = this.totalQtyOnHand + c.qtyOnHand;
            });
            
        });

        this._commonLookupService.getAllBaseUnitForTableDropdown().subscribe((result) => {
            this.allUnits = result;
        });
        this._commonLookupService.getAllCartonUnitsForTableDropdown().subscribe((result) => {
            this.allCartonUnits = result;
        });
        this._commonLookupService.getAllDepartmentForTableDropdown().subscribe((result) => {
            this.allDepartments = result;
        });
        this._commonLookupService.getAllCategoryForTableDropdown().subscribe((result) => {
            this.allCategorys = result;
        });
        this._commonLookupService.getAllSubCategoryForTableDropdown().subscribe((result) => {
            this.allSubCategorys = result;
        });
        this._commonLookupService.getAllBrandForTableDropdown().subscribe((result) => {
            this.allBrands = result;
        });
        this._commonLookupService.getAllVendorForTableDropdown().subscribe((result) => {
            this.allVendors = result;
        });
        this._commonLookupService.getAllTaxForTableDropdown().subscribe((result) => {
            this.allTaxs = result;
        });

        this._commonLookupService.getAllRawMaterialProductsForTableDropdown().subscribe((result) => {
            this.allRawMaterials = result;
        });
    }

    selectedBarcodes: ProductBarcodeDto[] = [];
    newBarcode: string = '';

    addBarcode() {
        if (this.newBarcode.trim() && !this.product.productBarcodes.some((b) => b.barcode === this.newBarcode)) {
            this.productBarcode = new ProductBarcodeDto();
            this.productBarcode.barcode = this.newBarcode.trim();
            this.product.productBarcodes.push(this.productBarcode);
            this.newBarcode = '';
        }
    }

    deleteSelected() {
        this.product.productBarcodes = this.product.productBarcodes.filter((b) => !this.selectedBarcodes.includes(b));
        this.selectedBarcodes = [];
    }

    save(): void {
        this.saving = true;

        //if (this.product.productUnitMappings.length == 0)
        //    this.product.productUnitMappings = [];

        //if (this.product.productRawMaterialMappings.length == 0)
        //    this.product.productRawMaterialMappings = [];

        //this.product.productUnitMappings.forEach(c => {
        //    var unitMappingEdit = new ProductUnitMappingDto();
        //    if (c.unitId == null) {

        //    }
        //});

        this.product.productUnitMappings = this.product.productUnitMappings.filter(x => x.unitId > 0);
        this.product.productRawMaterialMappings = this.product.productRawMaterialMappings.filter(x => x.unitId > 0);
        debugger;
        this._productsServiceProxy
            .createOrEdit(this.product)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this._router.navigate(['/app/inventory/products']);
            });
    }

    saveAndNew(): void {
        this.saving = true;

        this.product.productUnitMappings = this.product.productUnitMappings.filter(x => x.unitId !== null && x.id !== undefined);
        this.product.productRawMaterialMappings = this.product.productRawMaterialMappings.filter(x => x.unitId !== null && x.id !== undefined);

        this._productsServiceProxy
            .createOrEdit(this.product)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                        this._productsServiceProxy.getProductForEdit(undefined).subscribe((result) => {
            this.product = result.product;
            this.product.productUnitMappings = result.productUnitMappings;
            this.product.productBarcodes = result.productBarcodes;
            this.unitName = result.unitName;
            this.departmentName = result.departmentName;
            this.categoryName = result.categoryName;
            this.subCategoryName = result.subCategoryName;
            this.brandName = result.brandName;
            this.vendorName = result.vendorName;
            this.taxName = result.taxName;

            this.product.isActive = true;
            if (this.product.productUnitMappings.length == 0) {
                this.addUnitMapping();
            }
        });
            });
    }

    goBack(): void {
        this._router.navigate(['/app/inventory/products']);
    }
}
